import type { TableView } from "owa-mail-list-store";
import type { MailListItemSelectionSource } from "owa-mail-store";
import { action } from "satcheljs";

/**
 * Called when an email is opened
 * @param tableView Where the selection took place
 * @param selectedNodeIds Selected mail item parts, if any
 * @param seletedRowKeys Selected mail items
 * @param mailListItemSelectionSource The source of selection
 */
export interface ON_KEYBOARD_UP_DOWNActionMessage {
    tableView: TableView;
    selectedNodeIds: string[];
    selectedRowKeys: string[];
    mailListItemSelectionSource: MailListItemSelectionSource;
}
const defaultExport: (tableView: TableView, selectedNodeIds: string[], selectedRowKeys: string[], mailListItemSelectionSource: MailListItemSelectionSource) => ON_KEYBOARD_UP_DOWNActionMessage = action("ON_KEYBOARD_UP_DOWN", (tableView: TableView, selectedNodeIds: string[], selectedRowKeys: string[], mailListItemSelectionSource: MailListItemSelectionSource): ON_KEYBOARD_UP_DOWNActionMessage => ({
    tableView,
    selectedNodeIds,
    selectedRowKeys,
    mailListItemSelectionSource,
}));
export default defaultExport;
